import SectionBuilder from '@alme/ui-web/modules/message-renderer-display-links/src/builders/sectionBuilder';
import {DefaultSettings, settings} from '@alme/ui-web/settings/settings-util';
import UrlLinkBuilder from "./customUrlLinkBuilder";
import {VNode} from 'virtual-dom';

type StepOutIcon = { renderIcon: (url: string) => VNode | undefined };

export default class CustomSectionBuilder extends SectionBuilder
{
    constructor(settings: DefaultSettings,
        stepOutIcon: StepOutIcon | null = null)
    {
        super(settings, stepOutIcon);
        this._urlLinkBuilder = new UrlLinkBuilder(settings, stepOutIcon);
    }

}



// WEBPACK FOOTER //
// ./modules/custom-message-renderer-display-links/builders/customSectionBuilder.ts